// A narrow loading animation that can be used in buttons.

import React from "react";
import Box from "./Box";

function ButtonLoading() {
  return (
    <Box display="flex" justifyContent="center" height={30}>
      <span class="rs-button-loading"></span>
    </Box>
  );
}

export default ButtonLoading;
